import { render, staticRenderFns } from "./ButtonLinkTemplateComponent.vue?vue&type=template&id=8bf5892e&lang=pug"
import script from "./ButtonLinkTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonLinkTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bf5892e')) {
      api.createRecord('8bf5892e', component.options)
    } else {
      api.reload('8bf5892e', component.options)
    }
    module.hot.accept("./ButtonLinkTemplateComponent.vue?vue&type=template&id=8bf5892e&lang=pug", function () {
      api.rerender('8bf5892e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/ButtonLinkTemplateComponent.vue"
export default component.exports